const ACTION_TYPES = {
    protest: '#dc2626',
    community_action: '#2563eb',
    mutual_aid: '#16a34a',
    education: '#9D00FF'
  };
  
  export default ACTION_TYPES;